import React from "react";
import { Navigate } from "react-router-dom";
import { NemontoPagesIndex, NemontoTemplatePage } from "../features/nemonto";
import RecipeDetailPage from "../features/nemonto/pages/recipe-detail-page";
import ShapeChallengesPage from "../features/nemonto/pages/shape-challenges-page";
import ChallengeDetailPage from "../features/nemonto/pages/challenge-detail-page";

//pages
import Groups from "../views/dashboard/app/groups";
import GroupDetail from "../views/dashboard/app/group-detail";
import FriendList from "../views/dashboard/app/friend-list";
import InfluencerList from "../views/dashboard/app/influencer-list";
import MyAds from "../views/dashboard/app/ads/my-ads";
import AdsDetails from "../views/dashboard/app/ads/adsDetails";
import ProfileImages from "../views/dashboard/app/profile-images";
import ProfileVideos from "../views/dashboard/app/profile-videos";
import Calendar from "../views/dashboard/app/calendar";
import Birthday from "../views/dashboard/app/birthday";
import Weather from "../views/dashboard/app/weather";
import Music from "../views/dashboard/app/music";
import CatergoryGrid from "../views/dashboard/store/store-category-grid";
import CatergoryList from "../views/dashboard/store/store-category-list";
import StoreDetail from "../views/dashboard/store/store-detail";
import StoreCheckout from "../views/dashboard/store/store-checkout";

//market and profile pages
import Market1 from "../views/dashboard/market-place/market1";
import Market2 from "../views/dashboard/market-place/market2";
import Profile1 from "../views/dashboard/profiles/profile1";
import Profile2 from "../views/dashboard/profiles/profile2";
import Profile3 from "../views/dashboard/profiles/profile3";

export const Layout1Router = [
  {
    path: "dashboards/app/groups",
    element: <Groups />,
  },
  {
    path: "dashboards/app/group-detail",
    element: <GroupDetail />,
  },
  {
    path: "dashboards/app/friend-list",
    element: <FriendList />,
  },
  {
    path: "dashboards/app/influencer-list",
    element: <InfluencerList />,
  },
  {
    path: "dashboards/app/influencer-challenges",
    element: <ShapeChallengesPage type="3" title="Shape Challenges" subtitle="Weekly recipe challenges hosted by teachers." />,
  },
  {
    path: "dashboards/app/dancecorner-challenges",
    element: <ShapeChallengesPage type="2" title="Nemonto Challenges" subtitle="Weekly recipe challenges hosted by schools." />,
  },
  {
    // Retired: the old Bootstrap-themed following list has been replaced
    // by the nemonto-styled /following screen. Kept as a redirect for old
    // links/bookmarks.
    path: "dashboards/app/following-list",
    element: <Navigate to="/following" replace />,
  },
  {
    // Retired: the old Bootstrap-themed follower list has been replaced by
    // the nemonto-styled /followers screen. Kept as a redirect for old
    // links/bookmarks.
    path: "dashboards/app/follower-list",
    element: <Navigate to="/followers" replace />,
  },
  {
    path: "dashboards/app/my-ads",
    element: <MyAds />,
  },
  {
    path: "dashboards/app/ads-details/:slug",
    element: <AdsDetails />,
  },
  {
    path: "dashboards/app/profile-images",
    element: <ProfileImages />,
  },
  {
    path: "dashboards/app/profile-videos",
    element: <ProfileVideos />,
  },
  {
    path: "dashboards/app/calendar",
    element: <Calendar />,
  },
  {
    path: "dashboards/app/birthday",
    element: <Birthday />,
  },
  {
    path: "dashboards/app/weather",
    element: <Weather />,
  },
  {
    path: "dashboards/app/music",
    element: <Music />,
  },
  {
    path: "dashboards/store/store-category-grid",
    element: <CatergoryGrid />,
  },
  {
    path: "dashboards/store/store-category-list",
    element: <CatergoryList />,
  },
  {
    path: "dashboards/store/store-detail",
    element: <StoreDetail />,
  },
  {
    path: "dashboards/store/store-checkout",
    element: <StoreCheckout />,
  },
  {
    path: "dashboards/market-place/market1",
    element: <Market1 />,
  },
  {
    path: "dashboards/market-place/market2",
    element: <Market2 />,
  },
  {
    path: "dashboards/profiles/profile1",
    element: <Profile1 />,
  },
  {
    path: "dashboards/profiles/profile2",
    element: <Profile2 />,
  },
  {
    path: "dashboards/profiles/profile3",
    element: <Profile3 />,
  },
  {
    // Nemonto design-prototype screens - kept inside the authenticated
    // Default layout (instead of the chromeless SimpleRouter) so the
    // Sidebar stays visible while browsing/closing them.
    path: "pages",
    element: <NemontoPagesIndex />,
  },
  {
    path: "pages/recipe/:id",
    element: <RecipeDetailPage />,
  },
  {
    path: "pages/challenge/:id",
    element: <ChallengeDetailPage />,
  },
  {
    path: "pages/:pageKey",
    element: <NemontoTemplatePage />,
  },
];
